import { Injectable } from '@angular/core';
import { DetachedRouteHandle } from '@angular/router';
import { RouteReuseService } from '@pxl/models/contracts';

@Injectable()
export class DefaultRouteReuseService implements RouteReuseService {
    public readonly storedRouteHandles = new Map<string, DetachedRouteHandle>();

    public delete(key: string) {
        this.storedRouteHandles.delete(key);
    }

    public set(key: string, handle: DetachedRouteHandle) {
        return this.storedRouteHandles.set(key, handle);
    }

    public has(key: string): boolean {
        return this.storedRouteHandles.has(key);
    }

    public get(key: string): DetachedRouteHandle {
        return this.storedRouteHandles.get(key);
    }

    public clear() {
        this.storedRouteHandles.clear();
    }
}
